import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getTaskComments } from 'api/comment.service';
import { useToast } from 'hooks/ui';
import type { TComment } from 'models/task-comment.model';
import { commentKeys } from './queryKeys';

export const useTaskCommentsGetQuery = (taskId: string) => {
  const toast = useToast();

  const query = useQuery({
    queryKey: commentKeys.task(taskId),
    queryFn: (): Promise<TComment[]> => getTaskComments(taskId),
    enabled: !!taskId,
    refetchOnWindowFocus: false,
  });

  const { error } = query;

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error, toast]);

  return query;
};
